module.exports = __webpack_public_path__ + "static/media/proj20_img21.b07d6047.jpg";